function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { themeCreator, BASE } from './core';
var TRANSPARENT = 'transparent';
var _BASE$palette = BASE.palette,
    BLUE = _BASE$palette.BLUE,
    RED = _BASE$palette.RED,
    GREEN = _BASE$palette.GREEN,
    PURPLE = _BASE$palette.PURPLE,
    GREY = _BASE$palette.GREY,
    WHITE = _BASE$palette.WHITE,
    BLACK = _BASE$palette.BLACK,
    ORANGE = _BASE$palette.ORANGE;
export var colors = {
  text: WHITE,
  disabledText: GREY[350],
  focus: BLUE[500],
  background: GREY[850],
  primary: {
    text: GREY[50],
    hover: BLUE[400],
    action: BLUE[500],
    active: BLUE[200],
    disabledBackground: GREY[700],
    disabledText: GREY[350]
  },
  error: {
    background: RED[100],
    graphic: RED[400],
    text: RED[400],
    textContrast: WHITE,
    hover: RED[300]
  },
  success: {
    background: GREEN[300],
    graphic: GREEN[500],
    text: GREEN[500],
    textContrast: BLACK,
    hover: GREEN[400]
  },
  warning: {
    background: ORANGE[300],
    graphic: ORANGE[500],
    text: ORANGE[500],
    textContrast: BLACK,
    hover: ORANGE[400]
  },
  info: {
    background: BLUE[200],
    graphic: BLUE[500],
    text: BLUE[500],
    textContrast: BLACK,
    hover: BLUE[400]
  },
  progress: {
    background: PURPLE[300],
    graphic: PURPLE[500],
    text: PURPLE[500],
    textContrast: BLACK,
    hover: PURPLE[400]
  },
  default: {
    background: GREY[500],
    graphic: GREY[500],
    text: GREY[800],
    textContrast: BLACK,
    hover: GREY[400]
  },
  backgroundShades: {
    softest: GREY[800],
    soft: GREY[750],
    medium: GREY[650],
    strong: GREY[500],
    overlay: 'rgba(0, 0, 0, .4)',
    card: {
      hover: GREY[800]
    }
  },
  scrollbar: {
    // Using rbga() here because firefox only accepts a single color value.
    // For example, opcaity property would not be respected here.
    thumb: 'rgba(255,255,255,0.3)',
    track: 'transparent'
  }
};
export var buttons = function buttons(core) {
  return {
    colors: {
      primary: {
        text: core.primary.text,
        border: core.primary.action,
        background: core.primary.action,
        hoverText: core.primary.text,
        hoverBorder: core.primary.hover,
        hoverBackground: core.primary.hover,
        activeText: core.primary.text,
        activeBorder: core.primary.active,
        activeBackground: core.primary.active,
        disabledText: core.primary.disabledText,
        disabledBorder: core.primary.disabledBackground,
        disabledBackground: core.primary.disabledBackground
      },
      secondary: {
        text: GREY[150],
        border: GREY[250],
        background: TRANSPARENT,
        hoverText: GREY[700],
        hoverBorder: GREY[200],
        hoverBackground: GREY[200],
        activeText: GREY[700],
        activeBorder: GREY[100],
        activeBackground: GREY[100],
        disabledText: GREY[500],
        disabledBorder: GREY[500],
        disabledBackground: TRANSPARENT
      },
      tertiary: {
        text: GREY[150],
        border: TRANSPARENT,
        background: TRANSPARENT,
        hoverText: GREY[700],
        hoverBorder: GREY[200],
        hoverBackground: GREY[200],
        activeText: GREY[700],
        activeBorder: GREY[100],
        activeBackground: GREY[100],
        disabledText: GREY[500],
        disabledBorder: TRANSPARENT,
        disabledBackground: TRANSPARENT
      },
      destruction: {
        text: WHITE,
        border: RED[400],
        background: RED[400],
        hoverText: WHITE,
        hoverBorder: RED[300],
        hoverBackground: RED[300],
        activeText: WHITE,
        activeBorder: RED[200],
        activeBackground: RED[200],
        disabledText: GREY[500],
        disabledBorder: GREY[650],
        disabledBackground: GREY[650]
      }
    }
  };
};
export var tables = function tables(core) {
  return {
    colors: {
      background: core.background,
      border: GREY[650],
      highlight: GREY[700],
      focus: core.focus,
      sortIndicatorDisabled: GREY[500],
      text: core.text
    }
  };
};
export var formElements = function formElements(core) {
  return {
    colors: {
      action: core.primary.action,
      selected: core.primary.action,
      hover: core.primary.hover,
      background: BLACK,
      disabledBackground: GREY[700],
      border: GREY[600],
      focus: core.focus,
      readOnly: GREY[600],
      placeholder: GREY[350],
      addon: GREY[600],
      highlight: GREY[550],
      warning: _objectSpread({}, core.warning, {
        graphic: ORANGE[500],
        text: ORANGE[500]
      }),
      success: _objectSpread({}, core.success, {
        graphic: GREEN[600],
        text: GREEN[600]
      }),
      error: _objectSpread({}, core.error),
      info: _objectSpread({}, core.info)
    },
    options: {
      background: core.backgroundShades.soft,
      text: GREY[250],
      highlight: GREY[550],
      selectedBackground: core.primary.action,
      selectedHighlightBackground: core.primary.hover,
      selectedText: core.primary.text,
      indicator: GREY[100]
    },
    dropzone: {
      activeBorder: "2px solid ".concat(BLUE[500]),
      border: "2px dashed ".concat(GREY[300]),
      errorBorder: "2px dashed ".concat(RED[300]),
      hoverBackground: BLUE[1000],
      hoverText: BLUE[200],
      text: WHITE
    },
    switch: {
      border: GREY[300],
      active: BLUE[500],
      inactive: GREY[300],
      hover: GREY[650]
    }
  };
};
export var popovers = {
  colors: {
    text: WHITE,
    hover: GREY[600],
    border: GREY[750],
    background: GREY[700]
  }
};
export var pagination = function pagination(core) {
  return {
    colors: {
      current: {
        text: WHITE,
        background: core.primary.action,
        border: core.primary.action
      },
      active: {
        text: WHITE,
        background: GREY[750],
        border: BLACK,
        hoverFill: GREY[550],
        hoverText: WHITE
      },
      disabled: {
        text: GREY[350],
        background: GREY[700],
        border: BLACK,
        disableFill: GREY[450],
        disableText: BLACK
      }
    }
  };
};
export var slider = function slider(core) {
  return {
    colors: {
      emptyTrack: GREY[600],
      activeTrack: core.primary.action,
      handleBackground: WHITE,
      handleBorder: core.primary.hover,
      disabledHandleBorder: core.primary.disabledText
    }
  };
};
export var stepper = function stepper(core) {
  return {
    borders: {
      normal: '1px solid',
      active: '4px solid'
    },
    colors: {
      normal: GREY[200],
      border: GREY[600],
      disabled: GREY[350],
      hover: core.text,
      active: core.text,
      complete: core.info.graphic
    },
    font: {
      normal: BASE.font.size.base,
      marker: BASE.font.size.xxxlarge,
      markerIcon: BASE.font.size.xlarge
    }
  };
};
export var tabs = {
  colors: {
    background: GREY[800],
    border: GREY[700],
    disabled: GREY[200],
    hover: GREY[750],
    active: GREY[850]
  }
};
export var footer = {
  border: "1px dashed ".concat(GREY[500])
};
export var shadows = {
  default: 'none'
};
export var toggleButtonBar = {
  colors: {
    text: GREY[150],
    hoverFill: GREY[200],
    hoverBorder: WHITE,
    hoverText: GREY[700],
    activeText: GREY[700],
    activeFill: GREY[150],
    activeBorder: GREY[200],
    border: GREY[150]
  }
};
export var theme = themeCreator(function (coreBase, _ref) {
  var coreColors = _ref.colors,
      coreButtons = _ref.buttons,
      header = _ref.header,
      coreFooter = _ref.footer,
      coreTables = _ref.tables,
      coreFormElements = _ref.formElements;
  return _objectSpread({
    name: 'dark'
  }, coreBase, {
    colors: _objectSpread({}, coreColors, {}, colors),
    buttons: _objectSpread({}, coreButtons, {}, buttons(colors)),
    header: header,
    footer: _objectSpread({}, coreFooter, {}, footer),
    tables: _objectSpread({}, coreTables, {}, tables(colors)),
    formElements: _objectSpread({}, coreFormElements, {}, formElements(colors)),
    pagination: pagination(colors),
    stepper: stepper(colors),
    popovers: popovers,
    shadows: shadows,
    slider: slider(colors),
    tabs: tabs,
    toggleButtonBar: toggleButtonBar
  });
});